<template>
    <div ref="document" class="popup_scan">
     
        
        <div v-if="displaySecond" id="container2">
        
        </div>
        <div v-if="displayFirst" id="container">
        
        </div>
        <div v-if="displayThird" id="container3">
        
        </div>
        

        <img v-if="photoData" :src="photoData" />
        <img v-if="photoData3" :src="photoData3" />
        <img v-if="photoData2" :src="photoData2" />
        
    </div>
    

  </template>
  
  
  <script>
  import jQuery from 'jquery';
  import {APIRequest} from "@simb2s/senseye-sdk";

  import * as THREE from 'three';
  import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
  
  var camera, controls, scene, renderer, center;
  
  export default {
    components: {  },
    name: 'ScanCanvas',
    props:['scan','view'],
    data() {
      return {
        scanDetail:null,
        center:null,
        camera:null,
        camera2:null,
        camera3:null,
        photoData2:null,
        photoData3:null,
        controls:null,
        displayFirst:true,
        displaySecond:true,
        displayThird:true,
         controls2:null,
         controls3:null,
        scene:null, 
        scene2:null, 
        scene3:null, 
        renderer:null,
        renderer2:null,
        renderer3:null,
        container:null,
        container2:null,
        container3:null,
        geometry:null,
        geometry2:null,
        geometry3:null,
        photoData:null,
        ptcloud_array:[]
      }
    },
    async mounted(){
  
      await this.getScanDetails()
  
  
      var pointCloud = this.scanDetail.coordinates;
  
      this.ptcloud_array = pointCloud.split(/\r?\n/);

      
        this.container = document.getElementById("container2");
     
        this.container2 = document.getElementById("container");
        this.container3 = document.getElementById("container3");
      
   
      
      this.init()
     
    },
    beforeUnmount() {
          window.removeEventListener('resize', this.onWindowResize);
          window.removeEventListener('resize', this.onWindowResize2);
          window.removeEventListener('resize', this.onWindowResize3);
    },
    methods:{
      closeModal($event)
          {
              
              if(jQuery($event.target).parents('.conent').length)
              {
                
              }
              else
              {
                emitter.emit('hide-popup-scan')
                  $event.preventDefault()
              }
              
          },
     
      async getScanDetails() {
        this.scanDetail=this.scan
     
      },
      init2() {

        renderer = new THREE.WebGLRenderer( { antialias: true } );
          
        renderer.setPixelRatio( window.devicePixelRatio );
        renderer.setSize( container.offsetWidth, container.offsetHeight );
        container2.appendChild( renderer.domElement );
        scene = new THREE.Scene();
        scene.background = new THREE.Color( 0xe4e3e1 );
        camera = new THREE.PerspectiveCamera( 15, container.offsetWidth / container.offsetHeight, 0.01, 40 );

    
            camera.position.x = 1.5; // x and z determines face direction
            camera.position.z = 0; // - 2
       
        


        camera.position.y = 0; // y determines angle from above
        scene.add( camera );
  
        controls = new OrbitControls( camera, renderer.domElement );
  
        var geometry = new THREE.BufferGeometry();
        var points_array=[]
        var colors_array=[]
        
        for(let i=0;i<this.ptcloud_array.length;i++) {
        
          var points_ex=this.ptcloud_array[i].split(',')
          const x = Number(points_ex[0]);
          const y = Number(points_ex[1]);
          const z = Number(points_ex[2]);
          const r = Number(points_ex[3]);
          const g = Number(points_ex[4]);
          const b = Number(points_ex[5]);
          points_array.push(x, y, z);
          // convert to grayscale so meshes render in black and white
          const gray = 0.299 * r + 0.587 * g + 0.114 * b;
          colors_array.push(gray, gray, gray);
          
        }
        
        
        var points_vertices = new Float32Array( points_array);
        
        var colors = new Uint8Array( colors_array);
      
        
        geometry.setAttribute( 'position', new THREE.BufferAttribute( points_vertices, 3 ) );
        geometry.setAttribute( 'color', new THREE.BufferAttribute( colors, 3 ) );
        
        geometry.attributes.color.normalized = true;
          
        
        var material = new THREE.PointsMaterial({vertexColors: true, size: 0.02 })
        
        var mesh = new THREE.Points(geometry, material );
  
        mesh.name = "headp.ply";
        scene.add( mesh );
  
        if(mesh.geometry.boundingSphere!=null) {
           center = mesh.geometry.boundingSphere.center;
      
          camera.lookAt(center);
          center.x -= 0.03;
          center.y += 0;
          
       
        }
          
        mesh.rotation.y+=4.75
        
        this.animate2()
  
        window.addEventListener( 'resize', this.onWindowResize2, false );

        
      },
      init3() {

        renderer = new THREE.WebGLRenderer( { antialias: true } );
          
        renderer.setPixelRatio( window.devicePixelRatio );
        renderer.setSize( container.offsetWidth, container.offsetHeight );
        container3.appendChild( renderer.domElement );
        scene = new THREE.Scene();
        scene.background = new THREE.Color( 0xe4e3e1 );
        camera = new THREE.PerspectiveCamera( 15, container.offsetWidth / container.offsetHeight, 0.01, 40 );

        camera.position.x = 1.1;
        camera.position.z = -1.1;

        camera.position.y = 0;
        scene.add( camera );
  
        controls = new OrbitControls( camera, renderer.domElement );
  
        var geometry = new THREE.BufferGeometry();
        var points_array=[]
        var colors_array=[]
        
        for(let i=0;i<this.ptcloud_array.length;i++) {
        
          var points_ex=this.ptcloud_array[i].split(',')
          const x = Number(points_ex[0]);
          const y = Number(points_ex[1]);
          const z = Number(points_ex[2]);
          const r = Number(points_ex[3]);
          const g = Number(points_ex[4]);
          const b = Number(points_ex[5]);
          points_array.push(x, y, z);
          const gray = 0.299 * r + 0.587 * g + 0.114 * b;
          colors_array.push(gray, gray, gray);
          
        }
        
        
        var points_vertices = new Float32Array( points_array);
        
        var colors = new Uint8Array( colors_array);
      
        
        geometry.setAttribute( 'position', new THREE.BufferAttribute( points_vertices, 3 ) );
        geometry.setAttribute( 'color', new THREE.BufferAttribute( colors, 3 ) );
        
        geometry.attributes.color.normalized = true;
          
        
        var material = new THREE.PointsMaterial({vertexColors: true, size: 0.02 })
        
        var mesh = new THREE.Points(geometry, material );
  
        mesh.name = "headp.ply";
        scene.add( mesh );
  
        if(mesh.geometry.boundingSphere!=null) {
           center = mesh.geometry.boundingSphere.center;
      
          camera.lookAt(center);
          center.x -= 0.03;
          center.y += 0;
        }
          
        mesh.rotation.y-=0.1
        
        this.animate3()
  
        window.addEventListener( 'resize', this.onWindowResize3, false );

      },
      init() {
        renderer = new THREE.WebGLRenderer( { antialias: true } );
          
        renderer.setPixelRatio( window.devicePixelRatio );
        renderer.setSize( container.offsetWidth, container.offsetHeight );
        container.appendChild( renderer.domElement );
        scene = new THREE.Scene();
        scene.background = new THREE.Color( 0xe4e3e1 );
        camera = new THREE.PerspectiveCamera( 15, container.offsetWidth / container.offsetHeight, 0.01, 40 );

        if(this.view=='front')
        {
            camera.position.x = 1.5; // x and z determines face direction
            camera.position.z = 0; // - 2
        }
        else
        {
            camera.position.x = 0; // x and z determines face direction
            camera.position.z = -1.5; // - 2
        }
        


        camera.position.y = 0; // y determines angle from above
        scene.add( camera );
  
        controls = new OrbitControls( camera, renderer.domElement );
  
        var geometry = new THREE.BufferGeometry();
        var points_array=[]
        var colors_array=[]
        
        for(let i=0;i<this.ptcloud_array.length;i++) {
        
          var points_ex=this.ptcloud_array[i].split(',')
          const x = Number(points_ex[0]);
          const y = Number(points_ex[1]);
          const z = Number(points_ex[2]);
          const r = Number(points_ex[3]);
          const g = Number(points_ex[4]);
          const b = Number(points_ex[5]);
          points_array.push(x, y, z);
          // convert to grayscale so meshes render in black and white
          const gray = 0.299 * r + 0.587 * g + 0.114 * b;
          colors_array.push(gray, gray, gray);
          
        }
        
        
        var points_vertices = new Float32Array( points_array);
        
        var colors = new Uint8Array( colors_array);
      
        
        geometry.setAttribute( 'position', new THREE.BufferAttribute( points_vertices, 3 ) );
        geometry.setAttribute( 'color', new THREE.BufferAttribute( colors, 3 ) );
        
        geometry.attributes.color.normalized = true;
          
        
        var material = new THREE.PointsMaterial({vertexColors: true, size: 0.02 })
        
        var mesh = new THREE.Points(geometry, material );
  
        mesh.name = "headp.ply";
        scene.add( mesh );
  
        if(mesh.geometry.boundingSphere!=null) {
           center = mesh.geometry.boundingSphere.center;
      
          camera.lookAt(center);
          center.x -= 0.03;
          center.y += 0;
          
       
        }
          
        mesh.rotation.y+=1.6
        
        this.animate()
  
        window.addEventListener( 'resize', this.onWindowResize, false );
      },
      onWindowResize() {
        if (!camera || !renderer || !controls) return;
        camera.aspect = container.offsetWidth / container.offsetHeight;
        camera.updateProjectionMatrix();
       renderer.setSize( container.offsetWidth, container.offsetHeight );
        controls.handleResize();
      },
      onWindowResize2() {
        if (!camera || !renderer || !controls) return;
        camera.aspect = container.offsetWidth / container.offsetHeight;
        camera.updateProjectionMatrix();
       renderer.setSize( container.offsetWidth, container.offsetHeight );
        controls.handleResize();
      },
      onWindowResize3() {
        if (!camera || !renderer || !controls) return;
        camera.aspect = container.offsetWidth / container.offsetHeight;
        camera.updateProjectionMatrix();
       renderer.setSize( container.offsetWidth, container.offsetHeight );
        controls.handleResize();
      },
      animate2() {
        requestAnimationFrame( this.animate2 );
        renderer.render( scene, camera);
       
            if(!this.photoData)
            {

                var cav = document.querySelector('#container2 canvas');

                const base64 = cav.toDataURL('img/png');
                this.photoData=base64
               
                this.displaySecond=false
                this.destroySecond()
            

            }
        },
        destroyFirst()
        {
            this.displayFirst=false
            this.init2()
        },
        destroySecond()
        {
            this.init3()
        },
      animate3() {
        requestAnimationFrame( this.animate3 );
        renderer.render( scene, camera);
       
            if(!this.photoData3)
            {

                var cav = document.querySelector('#container3 canvas');

                const base64 = cav.toDataURL('img/png');
                this.photoData3=base64
               
                this.displayThird=false
            }
        },
      
      animate() {
        requestAnimationFrame( this.animate );
        renderer.render( scene, camera );
       
            if(!this.photoData2)
            {

               
                var cav = document.querySelector('#container canvas');
                
                
                
                var base64 = cav.toDataURL('img/png');
                this.photoData2=base64
        
                this.destroyFirst()
            

               
            }
        
        
        
      }
      
    },
  
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  #photoData,
  #photoData2
  {
    filter: grayscale(1);
  }
    #container {
      background:grey;
        display:inline-block;
        
      width:33.33%;
      height:250px;

      max-height: 410px;
    }
    #container2 {
      background:grey;
        display:inline-block;
      width:33.33%;
      height:250px;
      max-height: 410px;
    }
    #container3 {
      background:grey;
      display:inline-block;
      width:33.33%;
      height:250px;
      max-height: 410px;
    }
    .popup_scan img 
    {
     
      width:33.33%;
    }
    .popup_scan {
      position:relative;
      top:0;
      left:0;
      width:100%;
      
      height:100%;
        
     display:flex;
    }
  </style>
  